// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dashboard-1"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M10 12H3V21H10V12Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M14 3H21V12H14V3Z"}}]},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M10 3H3V8H10V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M21 16H14V21H21V16Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M10 12H3V21H10V12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M14 3H21V12H14V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M10 3H3V8H10V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M21 16H14V21H21V16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const Dashboard1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dashboard-1',
    ref,
    icon: element,
  },
));

Dashboard1Icon.displayName = 'Dashboard1Icon';

export default Dashboard1Icon;
